import {
    Card, FormControl, FormControlLabel, Modal, RadioGroup, Radio,
    Select, MenuItem, InputLabel, Checkbox, TextField, Button, Tabs, Tab, Stack, Chip, IconButton, CircularProgress, Switch
} from '@mui/material'
import React, { useMemo, useState, useEffect, useCallback } from 'react'
import CancelButton from 'src/components/shared/CancelButton'
import CompleteButton from 'src/components/shared/CompleteButton'
import Services from 'src/services/Services'

// MUI DatePicker importları
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { tr } from 'date-fns/locale'
import { toast } from 'react-toastify'

// İkonlar
import AddIcon from '@mui/icons-material/Add'
import CloseIcon from '@mui/icons-material/Close'
import DownloadIcon from '@mui/icons-material/Download'
import QueryStatsIcon from '@mui/icons-material/QueryStats'
import UndoIcon from '@mui/icons-material/Undo'
import DynamicTable from 'src/components/shared/DynamicTable'
import api from 'src/services/BaseService'

// Görsel durum chip’i
const statusChip = (status) => {
    const color =
        status === 'Aktif' ? 'success' :
            status === 'Görüntülendi' ? 'warning' :
                status === 'Kullanıldı' ? 'info' :
                    status === 'Süresi Doldu' ? 'default' :
                        'default'
    return <Chip size="small" label={status} color={color} variant="outlined" />
}

export default function AddBolParaCoupon({ open, onClose, company, getCompanies }) {
    const parsedUser = JSON.parse(localStorage.getItem('user'))

    console.log(company)
    // Görünüm: liste / ekleme formu
    const [view, setView] = useState('list')

    // Form state
    const [campaignOrCompany, setCampaignOrCompany] = useState("")
    const [campaignList, setCampaignList] = useState([])
    const [selectedCampaignID, setSelectedCampaignID] = useState("")
    const [isOneTime, setIsOneTime] = useState(false)
    const [expiryDate, setExpiryDate] = useState(null)
    const [couponsText, setCouponsText] = useState("")
    const [description, setDescription] = useState("");
    const parsedCoupons = useMemo(() => {
        return couponsText
            .split(/\r?\n|,/g)
            .map(s => s.trim())
            .filter(Boolean)
    }, [couponsText])

    const [bulkUseOpen, setBulkUseOpen] = useState(false)
    const [bulkUseText, setBulkUseText] = useState("")
    const [bulkUseLoading, setBulkUseLoading] = useState(false)
    const [bulkUseTarget, setBulkUseTarget] = useState(null)

    // Tablar: 0 = Marka bazlı, 1 = Kampanya bazlı
    const [tab, setTab] = useState(0)

    // Kampanya bazlı görünümde seçili kampanya (kupon detayı için)
    const [selectedTabCampaignID, setSelectedTabCampaignID] = useState(null)

    // Listeler
    const [brandCoupons, setBrandCoupons] = useState([])
    const [campaignCoupons, setCampaignCoupons] = useState([])

    // Loading durumları
    const [loadingBrand, setLoadingBrand] = useState(false)
    const [loadingCampaignList, setLoadingCampaignList] = useState(false)
    const [loadingCampaignCoupons, setLoadingCampaignCoupons] = useState(false)

    // --- YENİ: Inline "Liste ile Kullan" panelleri için state'ler ---
    const [brandListUseOpen, setBrandListUseOpen] = useState(false)
    const [brandListUseText, setBrandListUseText] = useState("")
    const [brandListUseLoading, setBrandListUseLoading] = useState(false)

    const [campaignListUseOpen, setCampaignListUseOpen] = useState(false)
    const [campaignListUseText, setCampaignListUseText] = useState("")
    const [campaignListUseLoading, setCampaignListUseLoading] = useState(false)

    const [brandGetBtnVisible, setBrandGetBtnVisible] = useState(
        company?.brandBasedGetCouponButtonVisibleStatus === "1"
    )
    const [saveBrandGetBtnLoading, setSaveBrandGetBtnLoading] = useState(false)

    const formatDateDMY = (dateLike) => {
        if (!dateLike) return ''
        const d = (dateLike instanceof Date) ? dateLike : new Date(dateLike)
        if (Number.isNaN(d.getTime())) return ''
        const dd = String(d.getDate()).padStart(2, '0')
        const mm = String(d.getMonth() + 1).padStart(2, '0')
        const yyyy = d.getFullYear()
        return `${dd}/${mm}/${yyyy}`
    }
    // --- GÜNCEL: Status sıralama (Aktif > Görüntülendi > Kullanıldı > Süresi Doldu > İptal) ---
    const statusOrder = useMemo(() => ({
        'Aktif': 0,
        'Görüntülendi': 1,
        'Kullanıldı': 2,
        'Süresi Doldu': 3,
        'İptal': 4
    }), [])

    const parseCouponInput = useCallback((raw) => {
        return (raw || "")
            .split(/\r?\n|,/g)
            .map(s => s.trim())
            .filter(Boolean)
            .filter((v, i, arr) => arr.indexOf(v) === i)
    }, [])

    const bulkUseParsed = useMemo(() => parseCouponInput(bulkUseText), [bulkUseText, parseCouponInput])

    // inline paneller için parsed
    const brandListUseParsed = useMemo(() => parseCouponInput(brandListUseText), [brandListUseText, parseCouponInput])
    const campaignListUseParsed = useMemo(() => parseCouponInput(campaignListUseText), [campaignListUseText, parseCouponInput])

    const openBulkUse = (target /* 'brand' | 'campaign' */) => {
        setBulkUseTarget(target)
        setBulkUseText("")
        setBulkUseOpen(true)
    }

    const closeBulkUse = () => {
        setBulkUseOpen(false)
        setBulkUseText("")
        setBulkUseTarget(null)
    }

    const confirmBulkUse = async () => {
        if (!bulkUseParsed.length) {
            toast.error("Lütfen en az bir kupon kodu girin.")
            return
        }
        try {
            setBulkUseLoading(true)
            const res = await Services.UseBolparaCoupons(parsedUser.token, company.companyID, bulkUseParsed)
            if (res?.data?.status) {
                toast.success("Kuponlar 'kullanıldı' olarak güncellendi.")
                if (bulkUseTarget === "brand") {
                    fetchBrandCoupons()
                } else if (bulkUseTarget === "campaign" && selectedTabCampaignID) {
                    fetchCampaignCoupons(selectedTabCampaignID)
                }
                closeBulkUse()
            } else {
                toast.error(res?.data?.message || "İşlem başarısız.")
            }
        } catch (e) {
            toast.error("İşlem sırasında bir hata oluştu.")
        } finally {
            setBulkUseLoading(false)
        }
    }

    // --- Servis: Kampanya listesi (kampanya bazlı tab için) ---
    const fetchCampaigns = useCallback(() => {
        setLoadingCampaignList(true)
        Services.GetBolParaCompanyCampaigns(parsedUser.token, company.companyID)
            .then(res => {
                if (res?.data?.status) setCampaignList(res.data.result || [])
                else setCampaignList([])
            })
            .catch(() => setCampaignList([]))
            .finally(() => setLoadingCampaignList(false))
    }, [parsedUser?.token, company?.companyID])

    // --- helpers ---
    const epochToDate = (epochLike) => {
        if (!epochLike) return null
        const n = Number(epochLike)
        if (!Number.isFinite(n)) return null
        const d = new Date(n * 1000)
        const utcDate = new Date(d.toISOString().split("T")[0])
        return Number.isNaN(d.getTime()) ? null : utcDate
    }

    const deriveStatus = (item) => {
        if (String(item.isUsed) === "1") return "Kullanıldı"
        if (String(item.isViewed) === "1") return "Görüntülendi"
        const exp = epochToDate(item.expiredDateTime)
        if (exp && exp.getTime() < Date.now()) return "Süresi Doldu"
        if (String(item.status) === "0") return "İptal"
        return "Aktif"
    }

    const normalizeCoupon = (x, i) => {
        const usedAtDate = epochToDate(x.usedDateTime)
        const viewedAtDate = epochToDate(x.viewedDateTime)
        return {
            id: x.id ?? i,
            code: x.coupon_code ?? x.couponCode ?? x.code ?? "-",
            usedAt: usedAtDate ? formatDateDMY(usedAtDate) : null,        // DD/MM/YYYY
            viewedAt: viewedAtDate ? formatDateDMY(viewedAtDate) : null,  // DD/MM/YYYY
            viewedPoi: x.poiTitle ?? null,
            status: deriveStatus(x),
            _raw: x,
            _expiredAt: epochToDate(x.expiredDateTime),
            _createdAt: epochToDate(x.createdDateTime),
            _usedAt: usedAtDate || null,        // sıralama için
            _viewedAt: viewedAtDate || null,    // sıralama için
            couponID: x.couponID,
            campaignID: x.campaignID ? x.campaignID : null
        }
    }

    // --- Servis: Kupon listesi (marka bazlı) ---
    const fetchBrandCoupons = useCallback(() => {
        setLoadingBrand(true)
        Services.GetBolparaCoupons(parsedUser.token, company.companyID, null)
            .then(res => {
                const list = res?.data?.result || []
                const filtered = list.filter(x => String(x.isCompanyBased) === "1")
                const normalized = filtered.map(normalizeCoupon)
                setBrandCoupons(normalized)
            })
            .catch(() => setBrandCoupons([]))
            .finally(() => setLoadingBrand(false))
    }, [parsedUser?.token, company?.companyID])

    // --- Servis: Kupon listesi (kampanyaya göre) ---
    const fetchCampaignCoupons = useCallback((campaignID) => {
        if (!campaignID) return
        setLoadingCampaignCoupons(true)
        Services.GetBolparaCoupons(parsedUser.token, company.companyID, campaignID)
            .then(res => {
                const list = res?.data?.result || []
                const filtered = list.filter(x => String(x.isCampaignBased) === "1")
                const normalized = filtered.map(normalizeCoupon)
                setCampaignCoupons(normalized)
            })
            .catch(() => setCampaignCoupons([]))
            .finally(() => setLoadingCampaignCoupons(false))
    }, [parsedUser?.token, company?.companyID])

    // Modal açılınca varsayılana dön
    useEffect(() => {
        if (open) {
            setView('list')
            setTab(0)
            setSelectedTabCampaignID(null)
            fetchBrandCoupons()
            setBrandGetBtnVisible(company?.brandBasedGetCouponButtonVisibleStatus === "1")
        }
    }, [open, fetchBrandCoupons, company])

    const handleToggleBrandGetBtnVisible = async (e) => {
        const nextChecked = e.target.checked
        // optimistic update
        setBrandGetBtnVisible(nextChecked)
        try {
            setSaveBrandGetBtnLoading(true)
            const res = await Services.UpdateBolParaCompanyBasedGetCouponButtonVisibleStatus(
                parsedUser.token,
                company.companyID,
                nextChecked ? "1" : "0",
                company.title,
                company.status
            )
            console.log(res.data)
            if (res?.data?.status) {
                toast.success(`Kupon alma butonu ${nextChecked ? 'Aktif' : 'Pasif'} yapıldı.`)
                getCompanies(parsedUser.token)
            } else {
                setBrandGetBtnVisible(!nextChecked) // revert
                toast.error(res?.data?.message || 'Güncelleme başarısız.')
            }
        } catch {
            setBrandGetBtnVisible(!nextChecked) // revert
            toast.error('Güncelleme sırasında hata oluştu.')
        } finally {
            setSaveBrandGetBtnLoading(false)
        }
    }

    // Tab değişince gerekli olanları çek
    useEffect(() => {
        if (!open) return
        if (tab === 0) {
            fetchBrandCoupons()
        } else if (tab === 1) {
            fetchCampaigns()
            setSelectedTabCampaignID(null)
            setCampaignCoupons([])
        }
    }, [tab, open, fetchBrandCoupons, fetchCampaigns])

    // Kampanya detayı görünümü seçildiğinde kuponları çek
    useEffect(() => {
        if (selectedTabCampaignID) {
            fetchCampaignCoupons(selectedTabCampaignID)
        }
    }, [selectedTabCampaignID, fetchCampaignCoupons])

    // --- Form üstü seçim ---
    const handleScopeChange = (event) => {
        const value = event.target.value
        setCampaignOrCompany(value)
        if (value === "1") {
            fetchCampaigns()
        } else {
            setCampaignList([])
            setSelectedCampaignID("")
        }
    }

    // --- Kupon oluştur ---
    const handleComplete = () => {
        if (!expiryDate) {
            toast.error('Lütfen son kullanma tarihi seçin.')
            return
        }
        if (!parsedCoupons.length) {
            toast.error('Lütfen en az bir kupon girin.')
            return
        }
        const companyBased = campaignOrCompany === "1" ? false : true
        Services.CreateBolparaCoupon(
            parsedUser.token,
            company.companyID,
            companyBased,
            !companyBased,
            selectedCampaignID,
            parsedCoupons,
            isOneTime,
            expiryDate.toISOString().split("T")[0],
            description
        )
            .then((res) => {
                if (res.data.status) {
                    toast.success('Kuponlar Başarıyla Oluşturuldu.')
                    setView('list')
                    if (tab === 0) fetchBrandCoupons()
                    if (tab === 1 && selectedTabCampaignID) fetchCampaignCoupons(selectedTabCampaignID)
                    handleFormReset()
                } else {
                    toast.error("Kuponlar oluşturulurken bir hata oluştu")
                }
            })
            .catch(() => {
                toast.error("Bir hata oluştu")
            })
    }

    const handleFormReset = () => {
        setCampaignOrCompany("")
        setCampaignList([])
        setSelectedCampaignID("")
        setIsOneTime(false)
        setExpiryDate(null)
        setCouponsText("")
        setDescription("")
    }

    const handleOnClose = () => {
        handleFormReset()
        setCampaignCoupons([])
        setBrandCoupons([])
        setView('list')
        setTab(0)
        setSelectedTabCampaignID(null)
        onClose()
    }

    // ✅ Excel satırlarını "Görüntülenme Tarihi" + "Gösterilen Nokta" ile oluştur
    const buildCouponExcelRows = (list) => {
        return (list || []).map((x, index) => ({
            no: index + 1,
            code: x.code || '',
            viewedAt: x.viewedAt || '',
            viewedPoi: x.viewedPoi || '',   // ✅
            usedAt: x.usedAt || '',
            status: x.status || '',
        }))
    }

    // ✅ Excel header’a "Gösterilen Nokta" eklendi
    const postExcel = async ({ content, sheetTitle }) => {
        const payload = {
            type: 'excel',
            content,
            header: {
                'No': 'number',
                'Kupon': 'string',
                'Görüntülenme Tarihi': 'string',
                'Gösterilen Nokta': 'string',
                'Kullanım Tarihi': 'string',
                'Durumu': 'string',
            },
            sheetTitle,
        }

        const res = await api.post('excel/export', payload)
        if (res?.data?.status) {
            try {
                const newWindow = window.open(res.data.result, '_blank')
                if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
                    toast.warn('Pop-up engellendi. Lütfen engelleyiciyi devre dışı bırakın.')
                }
            } catch {
                toast.warn('Pop-up açılırken sorun oluştu.')
            }
        } else {
            toast.error(res?.data?.message || 'Excel oluşturulamadı.')
        }
    }

    const handleCancelAllBrand = () => {
        Services.CancelUnusedBolparaCoupons(parsedUser.token, company.companyID, null)
            .then(res => {
                if (res?.data?.status) {
                    toast.success('Aktif kuponlar iptal edildi.')
                    fetchBrandCoupons()
                } else {
                    toast.error('İptal işlemi başarısız.')
                }
            })
            .catch(() => toast.error('İptal işlemi sırasında hata oluştu.'))
    }
    const handleExportBrand = async () => {
        try {
            const rows = buildCouponExcelRows(brandCoupons)
            await postExcel({ content: rows, sheetTitle: 'Marka Bazlı Kuponlar' })
        } catch (e) {
            toast.error(e?.message || 'Excel aktarımında hata.')
        }
    }
    const handleReportBrand = () => {
        toast.info('Tarih ile raporlama – placeholder')
    }

    const handleCancelAllCampaign = (campaignID) => {
        Services.CancelUnusedBolparaCoupons(parsedUser.token, company.companyID, campaignID)
            .then(res => {
                if (res?.data?.status) {
                    toast.success('Kampanyadaki aktif kuponlar iptal edildi.')
                    fetchCampaignCoupons(campaignID)
                } else {
                    toast.error('İptal işlemi başarısız.')
                }
            })
            .catch(() => toast.error('İptal işlemi sırasında hata oluştu.'))
    }
    const handleExportCampaign = async () => {
        try {
            const rows = buildCouponExcelRows(campaignCoupons)
            const campTitle =
                (normalizedCampaignList.find(c => c.id === selectedTabCampaignID || c.campaignID === selectedTabCampaignID)?.title)
                || 'Kampanya Bazlı Kuponlar'
            await postExcel({ content: rows, sheetTitle: campTitle })
        } catch (e) {
            toast.error(e?.message || 'Excel aktarımında hata.')
        }
    }
    const handleReportCampaign = () => {
        toast.info('Tarih ile raporlama – placeholder')
    }

    const handleCancelSingle = (row) => {
        Services.CancelSingleUnusedBolparaCoupon(parsedUser.token, row.couponID)
            .then(res => {
                if (res?.data?.status) {
                    toast.success('Kupon iptal edildi.')
                    if (!row.campaignID) {
                        fetchBrandCoupons()
                    } else {
                        fetchCampaignCoupons(row.campaignID)
                    }
                } else {
                    toast.error('İptal işlemi başarısız.')
                }
            })
            .catch(() => toast.error('İptal işlemi sırasında hata oluştu.'))
    }
    const handleUseCoupon = (row) => {
        Services.UseSingleBolparaCoupon(parsedUser.token, company.companyID, row.code)
            .then(res => {
                if (res?.data?.status) {
                    toast.success('Kupon kullanıldı.')
                    if (!row.campaignID) {
                        fetchBrandCoupons()
                    } else {
                        fetchCampaignCoupons(row.campaignID)
                    }
                } else {
                    toast.error('Kuponu kullanma işlemi başarısız.')
                }
            })
            .catch(() => toast.error('Kuponu kullanma işlemi sırasında hata oluştu.'))
    }

    // ✅ Tablo başlıkları: "Görüntülenme Tarihi" + "Gösterilen Nokta" eklendi
    const brandHeaders = [
        { id: 'code', label: 'Kupon' },
        {
            id: 'viewedAt',
            label: 'Görüntülenme Tarihi',
            sortFunction: (r) => r._viewedAt ? r._viewedAt.getTime() : 0,
            format: (val) => val || '-',
        },
        {
            id: 'viewedPoi',
            label: 'Gösterilen Nokta',            // ✅ viewedPOI sütunu
            sortFunction: (r) => r.viewedPoi ? 1 : 0, // basit var/yok sıralaması; gerekirse özel sıralama eklenebilir
            format: (val) => val || '-',
        },
        {
            id: 'usedAt',
            label: 'Kullanım Tarihi',
            sortFunction: (r) => r._usedAt ? r._usedAt.getTime() : 0,
            format: (val) => val || '-',
        },
        {
            id: 'status',
            label: 'Durumu',
            sortFunction: (r) => (statusOrder[r.status] ?? 99),
            format: (val) => statusChip(val)
        },
        {
            id: 'cancel', label: 'İptal Et', align: 'center', sx: { width: 120 },
            format: (_, row) => (
                <Button variant="outlined" size="small" onClick={() => handleCancelSingle(row)}>
                    İptal Et
                </Button>
            )
        },
        {
            id: 'use', label: 'Kullan', align: 'center', sx: { width: 120 },
            format: (_, row) => (
                <Button variant="contained" size="small" onClick={() => handleUseCoupon(row)}>
                    Kullan
                </Button>
            )
        },
    ]

    const campaignListHeaders = [
        { id: 'title', label: 'Kampanya Adı' },
        {
            id: 'detail', label: 'Detaylar', align: 'right', sx: { width: 140 },
            format: (_, row) => (
                <Button variant="contained" size="small" onClick={() => setSelectedTabCampaignID(row.campaignID || row.id)}>
                    Detaylar
                </Button>
            )
        },
    ]

    // Kampanya kuponları, marka ile aynı kolon setini kullanıyor
    const campaignCouponsHeaders = brandHeaders

    const normalizedCampaignList = (campaignList || []).map((c, i) => ({
        id: c.id ?? c.campaignID ?? `cmp-${i}`,
        campaignID: c.campaignID ?? c.id,
        title: c.title ?? c.name ?? `Kampanya ${i + 1}`,
    }))

    return (
        <Modal
            sx={{ alignItems: 'center', justifyContent: 'center', display: 'flex' }}
            open={open}
        >
            <Card
                sx={{
                    padding: '20px',
                    overflowY: 'auto',
                    maxHeight: '95%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    width: view === 'list' ? 1000 : 520, // tablo genişliği az da olsa arttırıldı
                }}
            >
                {/* Üst bar */}
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <strong style={{ fontSize: 16 }}>Kupon Yönetimi</strong>
                        {view === 'add' && <Chip label="Kupon Ekle" size="small" color="primary" variant="outlined" />}
                    </Stack>
                    <Stack direction="row" spacing={1}>
                        {view === 'list' ? (
                            <Button onClick={() => setView('add')} startIcon={<AddIcon />} variant="contained">
                                Kupon Ekle
                            </Button>
                        ) : (
                            <Button onClick={() => setView('list')} startIcon={<UndoIcon />} variant="outlined">
                                Listeye Dön
                            </Button>
                        )}
                        <IconButton onClick={handleOnClose} aria-label="Kapat">
                            <CloseIcon />
                        </IconButton>
                    </Stack>
                </Stack>

                {/* ------ LISTE GÖRÜNÜMÜ ------ */}
                {view === 'list' && (
                    <>
                        <Tabs value={tab} onChange={(_, v) => { setTab(v); setSelectedTabCampaignID(null) }}>
                            <Tab label="Marka Bazlı Kuponlar" />
                            <Tab label="Kampanya Bazlı Kuponlar" />
                        </Tabs>

                        {/* Marka Bazlı Sekme */}
                        {tab === 0 && (
                            <div style={{ width: '100%' }}>
                                <Stack direction="column" spacing={1} flexWrap="wrap" >
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={brandGetBtnVisible}
                                                onChange={handleToggleBrandGetBtnVisible}
                                                disabled={saveBrandGetBtnLoading}
                                            />
                                        }
                                        label={`Kupon Alma Butonu: ${brandGetBtnVisible ? 'Aktif' : 'Pasif'}`}
                                    />
                                    <Stack direction="row" spacing={1} flexWrap="wrap" alignItems="center">
                                        <Button variant="outlined" onClick={handleCancelAllBrand}>
                                            Tüm Aktif Kuponları İptal Et
                                        </Button>
                                        <Button variant="outlined" onClick={() => openBulkUse('brand')}>
                                            Toplu Kupon Listesi Kullanıldıya Çek
                                        </Button>
                                        <Button variant="outlined" startIcon={<DownloadIcon />} onClick={handleExportBrand}>
                                            Excele Aktar
                                        </Button>
                                        {/* YENİ: Liste ile Kullan */}
                                        <Button
                                            variant="outlined"
                                            onClick={() => { setBrandListUseOpen(p => !p); }}
                                        >
                                            Liste ile Kullan
                                        </Button>
                                    </Stack>

                                </Stack>

                                {/* YENİ: Inline panel */}
                                {brandListUseOpen && (
                                    <Card sx={{ p: 2, mt: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
                                        <TextField
                                            label="Kuponları Girin"
                                            placeholder={`Her satıra bir kupon yazın\nveya virgülle ayırın: ABC123, XYZ789`}
                                            multiline
                                            minRows={6}
                                            value={brandListUseText}
                                            onChange={(e) => setBrandListUseText(e.target.value)}
                                            helperText={`${brandListUseParsed.length} kupon algılandı`}
                                            fullWidth
                                        />
                                        <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-end">
                                            {brandListUseLoading && <CircularProgress size={20} />}
                                            <Button variant="outlined" onClick={() => { setBrandListUseOpen(false); setBrandListUseText(""); }} disabled={brandListUseLoading}>
                                                İptal
                                            </Button>
                                            <Button
                                                variant="contained"
                                                disabled={brandListUseLoading || brandListUseParsed.length === 0}
                                                onClick={async () => {
                                                    try {
                                                        setBrandListUseLoading(true)
                                                        const res = await Services.UseBolparaCoupons(parsedUser.token, company.companyID, brandListUseParsed)
                                                        if (res?.data?.status) {
                                                            toast.success("Kuponlar 'kullanıldı' olarak güncellendi.")
                                                            await fetchBrandCoupons()
                                                            setBrandListUseOpen(false)
                                                            setBrandListUseText("")
                                                        } else {
                                                            toast.error(res?.data?.message || "İşlem başarısız.")
                                                        }
                                                    } catch {
                                                        toast.error("İşlem sırasında bir hata oluştu.")
                                                    } finally {
                                                        setBrandListUseLoading(false)
                                                    }
                                                }}
                                            >
                                                Onayla
                                            </Button>
                                        </Stack>
                                    </Card>
                                )}

                                <DynamicTable
                                    data={brandCoupons}
                                    headers={brandHeaders}
                                    initialOrder={'status'}            // Aktif en üstte başlasın
                                    initalOrderDirection={'asc'}
                                    initialRowsPerPage={5}
                                />
                                {loadingBrand && (
                                    <Stack alignItems="center" mt={1}><CircularProgress size={24} /></Stack>
                                )}
                            </div>
                        )}

                        {/* Kampanya Bazlı Sekme */}
                        {tab === 1 && (
                            <div>
                                {/* Kampanya listesi */}
                                {!selectedTabCampaignID && (
                                    <>
                                        <DynamicTable
                                            data={normalizedCampaignList}
                                            headers={campaignListHeaders}
                                            initialOrder={'title'}
                                            initalOrderDirection={'asc'}
                                            initialRowsPerPage={5}
                                        />
                                        {loadingCampaignList && (
                                            <Stack alignItems="center" mt={1}><CircularProgress size={24} /></Stack>
                                        )}
                                    </>
                                )}

                                {/* Seçili kampanyanın kuponları */}
                                {selectedTabCampaignID && (
                                    <>
                                        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ px: 3 }}>
                                            <Stack direction="row" spacing={1} alignItems="center">
                                                <Button variant="text" onClick={() => { setSelectedTabCampaignID(null); setCampaignCoupons([]) }}>
                                                    ← Kampanyalara Dön
                                                </Button>
                                                <Chip
                                                    size="small"
                                                    color="primary"
                                                    label={
                                                        normalizedCampaignList.find(c => c.id === selectedTabCampaignID || c.campaignID === selectedTabCampaignID)?.title
                                                        || 'Kampanya'
                                                    }
                                                />
                                            </Stack>
                                        </Stack>

                                        <Stack direction="row" spacing={1} flexWrap="wrap" alignItems="center" mt={3}>
                                            <Button variant="outlined" onClick={() => handleCancelAllCampaign(selectedTabCampaignID)}>
                                                Tüm Aktif Kuponları İptal Et
                                            </Button>
                                            <Button variant="outlined" onClick={() => openBulkUse('campaign')}>
                                                Toplu Kupon Listesi Kullanıldıya Çek
                                            </Button>
                                            <Button variant="outlined" startIcon={<DownloadIcon />} onClick={handleExportCampaign}>
                                                Excele Aktar
                                            </Button>
                                            {/* YENİ: Liste ile Kullan */}
                                            <Button
                                                variant="outlined"
                                                onClick={() => { setCampaignListUseOpen(p => !p); }}
                                            >
                                                Liste ile Kullan
                                            </Button>
                                        </Stack>

                                        {/* YENİ: Inline panel (kampanya) */}
                                        {campaignListUseOpen && (
                                            <Card sx={{ p: 2, mt: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
                                                <TextField
                                                    label="Kuponları Girin"
                                                    placeholder={`Her satıra bir kupon yazın\nveya virgülle ayırın: ABC123, XYZ789`}
                                                    multiline
                                                    minRows={6}
                                                    value={campaignListUseText}
                                                    onChange={(e) => setCampaignListUseText(e.target.value)}
                                                    helperText={`${campaignListUseParsed.length} kupon algılandı`}
                                                    fullWidth
                                                />
                                                <Stack direction="row" spacing={1} alignItems="center" justifyContent="flex-end">
                                                    {campaignListUseLoading && <CircularProgress size={20} />}
                                                    <Button variant="outlined" onClick={() => { setCampaignListUseOpen(false); setCampaignListUseText(""); }} disabled={campaignListUseLoading}>
                                                        İptal
                                                    </Button>
                                                    <Button
                                                        variant="contained"
                                                        disabled={campaignListUseLoading || campaignListUseParsed.length === 0}
                                                        onClick={async () => {
                                                            try {
                                                                setCampaignListUseLoading(true)
                                                                const res = await Services.UseBolparaCoupons(parsedUser.token, company.companyID, campaignListUseParsed)
                                                                if (res?.data?.status) {
                                                                    toast.success("Kuponlar 'kullanıldı' olarak güncellendi.")
                                                                    await fetchCampaignCoupons(selectedTabCampaignID)
                                                                    setCampaignListUseOpen(false)
                                                                    setCampaignListUseText("")
                                                                } else {
                                                                    toast.error(res?.data?.message || "İşlem başarısız.")
                                                                }
                                                            } catch {
                                                                toast.error("İşlem sırasında bir hata oluştu.")
                                                            } finally {
                                                                setCampaignListUseLoading(false)
                                                            }
                                                        }}
                                                    >
                                                        Onayla
                                                    </Button>
                                                </Stack>
                                            </Card>
                                        )}

                                        <DynamicTable
                                            data={campaignCoupons}
                                            headers={campaignCouponsHeaders}
                                            initialOrder={'status'}        // Aktif en üstte başlasın
                                            initalOrderDirection={'asc'}
                                            initialRowsPerPage={5}
                                        />
                                        {loadingCampaignCoupons && (
                                            <Stack alignItems="center" mt={1}><CircularProgress size={24} /></Stack>
                                        )}
                                    </>
                                )}
                            </div>
                        )}
                    </>
                )}

                {/* ------ EKLEME FORMU GÖRÜNÜMÜ ------ */}
                {view === 'add' && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                        <FormControl component="fieldset" sx={{ marginTop: 2 }}>
                            <RadioGroup
                                row
                                name="status"
                                value={campaignOrCompany}
                                onChange={handleScopeChange}
                            >
                                <FormControlLabel value="1" control={<Radio />} label="Kampanya Bazlı" />
                                <FormControlLabel value="0" control={<Radio />} label="Marka Bazlı" />
                            </RadioGroup>
                        </FormControl>

                        {campaignOrCompany === "1" && (
                            <FormControl fullWidth>
                                <InputLabel id="campaign-select-label">Kampanya Seçin</InputLabel>
                                <Select
                                    label="Kampanya Seçin"
                                    labelId="campaign-select-label"
                                    value={selectedCampaignID}
                                    onChange={(e) => setSelectedCampaignID(e.target.value)}
                                    displayEmpty
                                >
                                    <MenuItem value="">
                                        Kampanya Seçin
                                    </MenuItem>
                                    {(campaignList || []).map((c, idx) => (
                                        <MenuItem key={c.campaignID ?? c.id ?? idx} value={c.campaignID ?? c.id}>
                                            {c.title ?? c.name ?? `Kampanya ${idx + 1}`}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        )}

                        <FormControlLabel
                            control={<Checkbox checked={isOneTime} onChange={(e) => setIsOneTime(e.target.checked)} />}
                            label="Tek seferlik kupon mu?"
                        />

                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={tr}>
                            <DatePicker
                                label="Son Kullanma Tarihi"
                                value={expiryDate}
                                onChange={(newValue) => setExpiryDate(newValue)}
                                slotProps={{ textField: { fullWidth: true } }}
                            />
                        </LocalizationProvider>

                        <TextField
                            label="Açıklama"
                            placeholder={`Kupon açıklaması girebilirsiniz.`}
                            multiline
                            minRows={5}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            fullWidth
                        />

                        <TextField
                            label="Kuponları Toplu Girin"
                            placeholder={`Her satıra bir kupon yazın\nveya virgülle ayırın: ABC123, XYZ789`}
                            multiline
                            minRows={5}
                            value={couponsText}
                            onChange={(e) => setCouponsText(e.target.value)}
                            helperText={`${parsedCoupons.length} kupon algılandı`}
                            fullWidth
                        />

                        <div style={{ width: '100%', alignItems: 'center', justifyContent: 'flex-end', gap: '15px', display: 'flex', marginTop: '15px' }}>
                            <CancelButton sx={{ width: '50%' }} onClick={handleOnClose} label={"Kapat"} />
                            <CompleteButton sx={{ width: '50%' }} onClick={handleComplete} label={"Kaydet"} />
                        </div>
                    </div>
                )}

                {/* (MEVCUT) Modal: Toplu Kullanıldıya Çek */}
                <Modal
                    open={bulkUseOpen}
                    onClose={closeBulkUse}
                    sx={{ alignItems: 'center', justifyContent: 'center', display: 'flex' }}
                >
                    <Card
                        sx={{
                            p: 2,
                            width: 520,
                            maxHeight: '90%',
                            overflowY: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2
                        }}
                    >
                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                            <strong style={{ fontSize: 16 }}>
                                Toplu Kullanıldıya Çek
                            </strong>
                            <IconButton onClick={closeBulkUse}><CloseIcon /></IconButton>
                        </Stack>

                        <TextField
                            label="Kuponları Girin"
                            placeholder={`Her satıra bir kupon yazın\nveya virgülle ayırın: ABC123, XYZ789`}
                            multiline
                            minRows={6}
                            value={bulkUseText}
                            onChange={(e) => setBulkUseText(e.target.value)}
                            helperText={`${bulkUseParsed.length} kupon algılandı`}
                            fullWidth
                        />

                        <Stack direction="row" spacing={1} alignItems="center">
                            <Chip
                                size="small"
                                variant="outlined"
                                label={
                                    bulkUseTarget === "brand"
                                        ? "Marka Bazlı Liste"
                                        : bulkUseTarget === "campaign"
                                            ? "Kampanya Bazlı Liste"
                                            : "—"
                                }
                            />
                            {bulkUseLoading && <CircularProgress size={20} />}
                        </Stack>

                        <Stack direction="row" spacing={1} justifyContent="flex-end">
                            <Button variant="outlined" onClick={closeBulkUse} disabled={bulkUseLoading}>
                                İptal
                            </Button>
                            <Button
                                variant="contained"
                                onClick={confirmBulkUse}
                                disabled={bulkUseLoading || bulkUseParsed.length === 0}
                            >
                                Onayla
                            </Button>
                        </Stack>
                    </Card>
                </Modal>
            </Card>
        </Modal>
    )
}